module.exports = __webpack_public_path__ + "img/header-weddingRingsMulticolor@2x.eeba9d0.webp";